import { Recipient } from './Recipient';
import { Translation } from './Translation';

export interface ResearchInvite {
  research_group_id: string;
  scheduled_at: string;
  translations: Translation[];
  recipients: Recipient[];
}
